<div class="column-popover p-2">

  <div class="row-popover">
    <i class="fas fa-circle fa-lg" [ngClass]="task?.status"></i>
    <i class="fa-regular fa-lg" [class]="setTaskIcon(task?.taskType)"></i>
    <h4 class="text-overflow" [title]="task?.name" style="font-size: 16px;">{{task?.name}}</h4>
    <div class="type-sign-box">
      <span class="type-sign-text">{{task?.signalingType|enumText: 'SignalingType'}}</span>
    </div>
    <i class="fas fa-flag fa-xl" [ngClass]="task?.priority"></i>
  </div>

  <div class="row-popover justify-content-start">
    <i class="far fa-map-location text-muted fa-xl"></i>
    <p class="text-muted m-0">{{addressTask}}</p>
  </div>

  <ng-container *ngIf="task?.progress?.activities > 0">
    <div class="column-popover">
      <div class="row-popover">
        <span>Atividade</span>
        <span>Progresso {{task?.progress?.completedActivities + '/' + task?.progress?.activities}}</span>
      </div>

      <div class="row-popover">
        <ng-container *ngFor="let item of arrayFromActivities; let i=index">
          <div class="progress-task-bar"
            [ngClass]="item < task?.progress?.completedActivities ? 'green-task-bar' : 'snow-task-bar'">
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <div class="row-popover">
    <h4>Atualizado: <span class="text-muted ml-1" style="font-weight: 400">{{task?.updatedAt | date:
        'dd/MM/yyyy'}}</span>
    </h4>
  </div>

  <div class="row-popover">
    <div class="team-vehicle-link">
      <img class="image-rounded" *ngIf="task?.teamId"
        [src]="task?.team?.leaderMember?.user?.imageURL ? task.team?.leaderMember?.user?.imageURL : 'assets/icons/camera.svg'">

      <i *ngIf="task?.teamId && task?.vehicles?.[0]?.id" class="fa-solid fa-link text-muted"></i>

      <img class="image-rounded" *ngIf="task?.vehicles?.[0]?.id"
        [src]="task?.vehicles?.[0]?.vehicleImage?.url ? task?.vehicles?.[0]?.vehicleImage?.url : 'assets/icons/camera.svg'">
    </div>
    <button (click)="openTaskDetails()" id="detailsButton"
      class="btn btn-link detail-sidebar-button ml-auto">
      VER DETALHES <i class="fas fa-angle-right ml-2 mr-0" style="font-size: 20px;"></i>
    </button>
  </div>
</div>
